var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { selectPayEnrollOfferUrl } from '../services/select-pay/select-pay-api';
import useFetch from '../services/use-fetch';
import { selectPayPaymentCacheKey } from './use-select-pay-eligibility';
export var selectPayMutationErrorCodes = {
    errorLimitCode: '600014',
    errorDisputesCode: '600015'
};
export var selectPayMutationCacheKey = function (_a) {
    var accountId = _a.accountId, accountIdType = _a.accountIdType;
    return [selectPayEnrollOfferUrl, { accountId: accountId, accountIdType: accountIdType }];
};
export default function useSelectPayMutation(_a) {
    var _this = this;
    var apiConfig = _a.apiConfig, promotionalOfferId = _a.promotionalOfferId, transactionOfferId = _a.transactionOfferId;
    var _b = apiConfig.keyProps, accountId = _b.accountId, accountIdType = _b.accountIdType;
    var fetchWrapper = useFetch(apiConfig.config);
    var queryClient = useQueryClient();
    return useMutation({
        mutationKey: selectPayMutationCacheKey({ accountId: accountId, accountIdType: accountIdType }),
        mutationFn: function () {
            return fetchWrapper(selectPayEnrollOfferUrl, {
                body: JSON.stringify({
                    'cipher.accountId': accountId,
                    accountIdType: accountIdType,
                    transactionOfferId: transactionOfferId,
                    promotionalOfferId: promotionalOfferId
                }),
                method: 'POST'
            });
        },
        onError: function (err) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, err.response.json()];
                    case 1: 
                    // NOTE: this is to catch the error object on API call
                    throw _a.sent();
                }
            });
        }); },
        onSuccess: function () {
            return queryClient.invalidateQueries(selectPayPaymentCacheKey({ accountId: accountId, accountIdType: accountIdType }));
        }
    });
}
//# sourceMappingURL=use-select-pay-mutation.js.map